export default __webpack_public_path__ + "static/media/equalHousingLender.ca1878fb.svg";